var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPinterestTabletFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M14.006 0C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H10.5V9.8h2.8V8.3h-2.8s-.35-1.892.484-2.674c.834-.78 2.316-.226 2.316-.226V2.7l-1.5.09c-1.945.117-3.56 1.78-3.632 3.716L8.1 8.3H6.3v1.5h1.8V16H1.994A1.995 1.995 0 0 1 0 14.006V1.994C0 .893.895 0 1.994 0z"
})));
export default SvgPinterestTabletFacebook;